<template>
  <component :is="componentType" :url="url" class="group">
    <span class="inline-flex items-center border-b-2 border-app-green">
      <div class="text-sm font-bold">
        <slot />
      </div>
      <AtomIconArrowRight class="ml-3 w-3 text-app-green transform group-hover:translate-x-1 transition duration-200" />
    </span>
  </component>
</template>

<script setup lang="ts">
interface Props {
  url?: string
}

const props = defineProps<Props>()

const AtomLink = resolveComponent('AtomLink')
const componentType = props.url ? AtomLink : 'button'
</script>
